import script from "./CricketGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./CricketGrid.vue?vue&type=script&setup=true&lang=js"

import "./CricketGrid.vue?vue&type=style&index=0&id=3b34d45f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b34d45f"]])

export default __exports__